import React from "react";

const SetupUsers = () => {
  return <div>SetupUsers</div>;
};

export default SetupUsers;
